module.exports = __webpack_public_path__ + "img/btn.b4eff452.png";